import { TriangleAlert, Minus } from 'lucide-react';
import { useActions } from '@/store/selectors';

/**
 * CDS notice banner (PSD §8.1.1 / TODO Task 1.17, 3.16).
 * Dismissable: the collapse control calls setCdsNoticeDismissed(true), which
 * persists in settingsSlice — so dismissal is permanent across sessions, not a
 * transient collapse. Long-term placement is tracked under Skill 3 (clarify).
 */
export function CdsNotice(): JSX.Element {
  const actions = useActions();
  const cdsText =
    'Clinical Decision Support — not a prescriber. All outputs require clinical judgment.';
  return (
    <div className="cds-notice" role="status" data-testid="cds-notice">
      <span className="cds-icon" aria-hidden="true">
        <TriangleAlert size={16} strokeWidth={2} />
      </span>
      <span className="cds-text">{cdsText}</span>
      <button
        className="cds-collapse"
        onClick={() => actions.setCdsNoticeDismissed(true)}
        aria-label="Collapse notice"
      >
        <Minus size={16} strokeWidth={2} aria-hidden="true" />
      </button>
    </div>
  );
}
